import { createReducer } from '@reduxjs/toolkit';

import { RESET_STORE } from '../../redux/store';
import { CaseDetailState, CasesEvent, SearchCasesState } from './type';
import { fetchCaseDetailAction, fetchCaseDetailStatusChangeAction, fetchCaseDetailRdnActivity } from './actions';

const INITIAL_STATE = {
  caseArchivedFromList: null,
  caseAssignUsers: {
    loading: false,
  },
};

export const casesReducer = (
  state: typeof INITIAL_STATE = INITIAL_STATE,
  action: {
    type: string;
    payload: unknown;
  } = {
    type: RESET_STORE,
    payload: null,
  },
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
): any => {
  switch (action.type) {
    case CasesEvent.CASE_ARCHIVED_FROM_LIST:
      return {
        ...state,
        caseArchivedFromList: action.payload,
      };
    case CasesEvent.CASE_ASSIGN_USERS:
      return {
        ...state,
        caseAssignUsers: action.payload,
      };
    case RESET_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export const INITIAL_SEARCH_CASES_STATE: SearchCasesState = {
  cases: [],
  searchText: '',
  isSearching: false,
};

export const INITIAL_CASE_DETAIL_STATE: CaseDetailState = {
  case: undefined,
  caseMissedRepossessions: null,
  isLoading: false,
  caseStatusChanges: {
    data: [],
    isLoading: true,
    count: 0,
  },
  rdnActivity: {
    data: [],
    isLoading: true,
    count: 0,
  },
};

export const caseDetailReducer = createReducer(INITIAL_CASE_DETAIL_STATE, (builder) => {
  builder.addCase(fetchCaseDetailAction.fulfilled, (state, action) => {
    return {
      ...state,
      case: action.payload.case,
      isLoading: false,
      caseMissedRepossessions: action.payload.caseMissedRepossessions,
    };
  });
  builder.addCase(fetchCaseDetailAction.pending, (state) => {
    return { ...state, isLoading: true };
  });
  builder.addCase(fetchCaseDetailAction.rejected, () => {
    return INITIAL_CASE_DETAIL_STATE;
  });
  // case status changes
  builder.addCase(fetchCaseDetailStatusChangeAction.pending, (state) => {
    return {
      ...state,
      caseStatusChanges: {
        data: [],
        isLoading: true,
        count: state.caseStatusChanges.count,
      },
    };
  });
  builder.addCase(fetchCaseDetailStatusChangeAction.fulfilled, (state, action) => {
    return {
      ...state,
      caseStatusChanges: {
        data: action.payload.data,
        count: action.payload.count,
        isLoading: false,
      },
    };
  });
  // case rdn activity
  builder.addCase(fetchCaseDetailRdnActivity.pending, (state) => {
    return {
      ...state,
      rdnActivity: {
        data: [],
        isLoading: true,
        count: state.caseStatusChanges.count,
      },
    };
  });
  builder.addCase(fetchCaseDetailRdnActivity.fulfilled, (state, action) => {
    return {
      ...state,
      rdnActivity: {
        data: action.payload.data,
        count: action.payload.count,
        isLoading: false,
      },
    };
  });
  builder.addDefaultCase((state) => state);
});
